import React, { useContext } from 'react'

import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings'

import type { ExperimentsStore } from 'shared/stores/experiments.store'
import { UserSessionContext } from 'shared/context/user-session-provider'
import { getCookies } from 'libs/common/cookies'

export const AppStatsigProvider: React.FC<{
  children: React.ReactNode
  clientKey: string
  experimentsStore: ExperimentsStore
}> = ({ children, clientKey, experimentsStore }) => {
  const { userSessionId } = useContext(UserSessionContext)
  const environment = { tier: process.env.ENV }
  const lang = getCookies('locale')

  const user = {
    userID: userSessionId,
    statsigEnvironment: environment,
    custom: {
      userSessionId: userSessionId,
      lang: lang,
    },
  }

  const { client } = useClientAsyncInit(clientKey, user)

  experimentsStore.setClient(client)

  return (
    <StatsigProvider sdkKey={clientKey} client={client} user={user}>
      {children}
    </StatsigProvider>
  )
}
